import { CellDoubleClickedEvent } from '@ag-grid-community/core';
import { Component, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';

@GridModalComponent('materialgrades')
@Component({
    selector: 'tt-material-grades',
    templateUrl: './material-grades.component.html',
    styleUrls: ['./material-grades.component.css'],
})
export class MaterialGradesComponent implements OnInit {
    //3903

    public grid?: GridOptions;

    @Output()
    public submit = new EventEmitter<GridRow>();

    constructor(
        private modal: ModalService,
        @Optional() @Inject(TT_STATE_DIALOG) private stateDialog: StateDialogContext,
    ) {
        this.initFromDialog(stateDialog);
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_materialgrades')
                .setLoadDataFunction({ method: 3903 })
                .setCustomToolbarButtons([
                    {
                        name: 'new_materialgrade',
                        text: 'new_materialgrade',
                        translate: true,
                        icon: 'far fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-l',
                        func: async () => {
                            const response = await this.modal.openStateDialog({ state: 'materialgrade', params: '0' });

                            if (!!response) {
                                this.grid?.gridfunc?.read();
                            }
                        },
                    },
                ])
                .setSpecialFunc({ buttons: [{ name: 'edit_materialgrade', icon: 'fas fa-pencil', btn_type: 'primary', func: this.openEditMaterialGrade.bind(this) }] });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async openEditMaterialGrade(row: GridRow) {
        console.log(row);
        if (!!row && 'materialgrade_keyno' in row) {
            const response = await this.modal.openStateDialog({ state: 'materialgrade', params: '' + row['materialgrade_keyno'] });

            if (!!response) {
                this.readGrid();
            }
        }
    }

    public onDoubleClick(event: CellDoubleClickedEvent) {
        this.submit.emit(event.node.data);
    }

    private async init() {
        this.readGrid();
    }

    ngOnInit(): void {
        this.readGrid();
    }

    private initFromDialog(state?: StateDialogContext) {
        if (!!state) {
            state.setSize({ width: 'min(160rem, 95vw)', height: 'min(95vh, 60rem)' });
            this.submit.subscribe({ next: (value: GridRow) => state.close(value) });
            state.setHeading('p2_m_materialgrades', true);
        }
    }
}
